import { Component } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { ActiveTag, InactiveTag, GreenCheck, CancelRed } from '../../../../svgIcons';
import { COLUMN_STYLES } from '../constants';

class StudentsDataTable extends Component {
    renderHeader() {
        const { globalFilterValue, onGlobalFilterChange } = this.props;
        
        return (
            <div className="flex justify-content-between align-items-center">
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText
                        value={globalFilterValue}
                        onChange={onGlobalFilterChange}
                        placeholder="Name / Phone Number"
                    />
                </span>
            </div>
        );
    }

    enrollmentBodyTemplate = (rowData) => {
        return <p>{`${rowData?.user_info?.enrollmentId}`}</p>;
    };

    studentNameBodyTemplate = (rowData) => {
        return (
            <p>
                {rowData?.user_info?.firstName 
                    ? `${rowData?.user_info?.firstName} ${rowData?.user_info?.lastName}` 
                    : rowData?.user_info?.given_name}
            </p>
        );
    };

    boardBodyTemplate = (rowData) => {
        return <p>{rowData ? `${rowData?.user_info?.["custom:board"]}` : null}</p>;
    };

    gradeSectionBodyTemplate = (rowData) => {
        return (
            <p>
                {rowData 
                    ? `${rowData?.user_info?.["custom:grade"]} - ${rowData?.user_info?.sectionName}` 
                    : null}
            </p>
        );
    };

    statusBodyTemplate = (rowData) => {
        return rowData?.user_info?.status === 'Active' ? <ActiveTag /> : <InactiveTag />;
    };

    approveRejectBodyTemplate = (rowData) => {
        const { onApprove, onReject } = this.props;
        
        return (
            <div className="flex justify-content-evenly">
                <div
                    className="cursor-pointer"
                    onClick={() => onApprove(rowData)}
                >
                    <GreenCheck />
                </div>
                <div
                    className="cursor-pointer"
                    onClick={() => onReject(rowData)}
                >
                    <CancelRed />
                </div>
            </div>
        );
    };

    render() {
        const {
            changeRequests,
            isLoading,
            lazyParams,
            totalRecords,
            filters,
            onPage,
            onSort,
            onFilter,
            onSelectionChange,
            selectedRows
        } = this.props;

        const header = this.renderHeader();

        return (
            <div className="card datatable-crud-demo ma-m30 m-2">
                <DataTable
                    ref={(el) => (this.dt = el)}
                    value={changeRequests}
                    dataKey="id"
                    paginator
                    className="dataTableValuesText"
                    responsiveLayout="scroll"
                    showGridlines
                    columnResizeMode="expand"
                    resizableColumns
                    onPage={onPage}
                    first={lazyParams.first}
                    last={totalRecords}
                    rows={lazyParams.rows}
                    totalRecords={totalRecords}
                    rowsPerPageOptions={[5, 10, 25, 50, 100]}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                    selection={selectedRows}
                    onSelectionChange={onSelectionChange}
                    selectionMode="checkbox"
                    lazy={false}
                    header={header}
                    filters={filters}
                    filterDisplay="menu"
                    loading={isLoading}
                    globalFilterFields={['name', 'phone_number']}
                >
                    <Column 
                        style={COLUMN_STYLES.DEFAULT} 
                        alignHeader={'center'} 
                        sortable 
                        headerClassName="text-color-secondary" 
                        bodyClassName="text-center" 
                        filterField="user_info?.enrollmentId" 
                        header="Enrollment No" 
                        body={this.enrollmentBodyTemplate} 
                    />
                    
                    <Column 
                        style={COLUMN_STYLES.DEFAULT} 
                        alignHeader={'center'} 
                        sortable 
                        headerClassName="text-color-secondary" 
                        bodyClassName="text-center" 
                        filterField="given_name" 
                        header="Student Name" 
                        body={this.studentNameBodyTemplate} 
                    />
                    
                    <Column 
                        style={COLUMN_STYLES.WIDER} 
                        alignHeader={'center'} 
                        sortable 
                        headerClassName="text-color-secondary" 
                        bodyClassName="text-center" 
                        header="Board" 
                        body={this.boardBodyTemplate} 
                    />
                    
                    <Column 
                        sortable 
                        bodyClassName='text-center' 
                        header="Grade-Section" 
                        alignHeader={"center"} 
                        body={this.gradeSectionBodyTemplate} 
                    />

                    <Column 
                        style={COLUMN_STYLES.DEFAULT} 
                        alignHeader={'center'} 
                        sortable 
                        headerClassName="text-color-secondary" 
                        bodyClassName="text-center" 
                        filterField="phoneNumber" 
                        field="user_info.parentContactNo" 
                        header="Phone Number" 
                    />

                    <Column
                        style={COLUMN_STYLES.DEFAULT}
                        alignHeader={'center'}
                        headerClassName="text-color-secondary"
                        bodyClassName="text-center"
                        header="Status"
                        body={this.statusBodyTemplate}
                    />

                    <Column
                        style={COLUMN_STYLES.DEFAULT}
                        alignHeader={'center'}
                        sortable
                        headerClassName="text-color-secondary"
                        bodyClassName="text-center"
                        header="Approve / Reject"
                        body={this.approveRejectBodyTemplate}
                    />
                </DataTable>
            </div>
        );
    }
}

export default StudentsDataTable;
